import React from 'react'
import { Link } from 'react-router-dom'
import '../App.css';
// MUI
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'


function Navbar() {

    function handleClick(){
        alert('🔴 DISCLAIMER 🔴: THESE LOCATIONS ARE NOT ACCURATE -- LOCATIONS HAVE BEEN ESTIMATED USING DIFFERENT PROBABILITIES')
    }
    return (
        <AppBar position='fixed' style={{width:'100%'}}>
            <Toolbar className="nav-container" style={{display:'flex', flex:1}}>
                <Button size="large" color='inherit' component={Link} to='/map' onClick={handleClick}>Map</Button>
                <Button size="large" color='inherit' component={Link} to='/summary'>Summary</Button>
                <Button size="large" color='inherit' component={Link} to='/submit'>Contribute!</Button>
            </Toolbar>
        </AppBar>
    )
}


export default Navbar
